export const CAMPAIGN_PLACEHOLDER_NAME = {
  TRADE_PAGE: "tradePage",
  PREDICTION_PAGE: "predictionPage",
  UNDEFINED: "undefined",
  UNKNOWN: "unknown",
} as const;
export type CAMPAIGN_PLACEHOLDER_NAME = (typeof CAMPAIGN_PLACEHOLDER_NAME)[keyof typeof CAMPAIGN_PLACEHOLDER_NAME];

export const CAMPAIGN_PLACEHOLDER_LIST = Object.values(CAMPAIGN_PLACEHOLDER_NAME) as string[];
